import { CircleUserIcon } from '@execonline-inc/execonline-ui';
import { mapMaybe } from '@execonline-inc/collections';
import { fromNullable, Maybe } from 'maybeasy';
import * as React from 'react';
import { findLink } from '../../../../../LinkyLinky';
import { CoachProfileResource } from '../../../../EmbeddedFormFieldAsset/Types';

interface Props {
  coach: Maybe<CoachProfileResource>;
}

// Tries the coaching profile image, then the coach's own profile photo, and
// moves to the next one when an image fails to load.
const avatarUrls = (coach: Maybe<CoachProfileResource>): ReadonlyArray<string> =>
  coach
    .map(({ links }) =>
      mapMaybe(
        (rel: 'avatar' | 'profile-avatar') => findLink(rel, links).map(({ href }) => href),
        ['avatar', 'profile-avatar'],
      ),
    )
    .map((urls) => urls.filter((url, i) => urls.indexOf(url) === i))
    .getOrElseValue([]);

function CoachAvatar({ coach }: Props) {
  const urls = avatarUrls(coach);
  const [failed, setFailed] = React.useState(0);

  return fromNullable(urls[failed])
    .map((url) => (
      <img
        key={url}
        src={url}
        alt=""
        className="h-16 w-16 shrink-0 rounded-full object-cover"
        onError={() => {
          setFailed(failed + 1);
        }}
        data-test-coach-avatar={true}
      />
    ))
    .getOrElse(() => (
      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <CircleUserIcon size="xl" color="inherit" />
      </div>
    ));
}

export default CoachAvatar;
